<template>
  <div>
    <div class="block">
      <el-form :inline="true">
        <el-form-item label="币种名称：">
          <el-input v-model="coinName" placeholder="请输入币种名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :plain="true" @click="queryPartnersAll">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="dialogVisible=true">新增项目方</el-button>
        </el-form-item>
      </el-form>
      <el-dialog title="新增项目方" :visible.sync="dialogVisible" width="60%" @close="clearFormData">
        <el-form :model="formData" label-width="120px" :label-position="'right'">
          <el-form-item label="用户ID">
            <el-input v-model="formData.userId" placeholder="请输入用户ID" required="required" clearable></el-input>
          </el-form-item>
          <el-form-item label="账户">
            <el-input v-model="formData.account" placeholder="请输入账户" clearable></el-input>
          </el-form-item>
          <el-form-item label="代币">
            <el-input v-model="formData.coin" placeholder="请输入代币" required="required" clearable></el-input>
          </el-form-item>
          <el-form-item label="计价币">
            <el-input v-model="formData.coinArea" placeholder="请输入计价币" required="required" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addPartner">立即创建</el-button>
            <el-button @click="clearFormData">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <div v-if="isShow">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column fixed prop="id" label="ID" sortable></el-table-column>
          <el-table-column prop="userId" label="用户ID" sortable></el-table-column>
          <el-table-column prop="account" label="账户" sortable></el-table-column>
          <el-table-column prop="coin" label="代币" sortable></el-table-column>
          <el-table-column prop="coinArea" label="计价币" sortable></el-table-column>
          <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!--            <el-button @click="update(scope.row)" type="primary" size="small">更新</el-button>-->
              <el-button @click="remove(scope.row)" type="danger" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background
                       layout="total, sizes, prev, pager, next, jumper"
                       :page-size="pageSize"
                       :page-sizes="[10, 20, 50, 100]"
                       :total="total"
                       :current-page="currentPageNum"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange">
        </el-pagination>
        <div style="margin: 20px 0 20px 0; text-align: right">
          <el-button type="primary" icon="el-icon-refresh" :plain="true" @click="exportExcel">导出excel</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from './utils'


const columns=[
  {title:'ID',key:'id'},
  {title:'用户ID',key:'userId'},
  {title:'账户',key:'account'},
  {title:'代币',key:'coin'},
  {title:'计价币',key:'coinArea'},
  {title:'创建时间',key:'createTime'}
]

export default {
  name: "PartnerInfo",
  data(){
    return{
      cache:'',
      coinName:'',
      isShow:false,
      pages:0,
      total:0,
      dialogVisible:false,
      tableData:[],
      currentPageNum:1,
      pageSize: 10,
      formData:{
        coin:'',
        coinArea:'',
        userId:'',
        account:''
      }
    }
  },
  methods:{
    deepCopy(source) {
      let sourceCopy = source instanceof Array ? [] : {};
      for (let item in source) {
        sourceCopy[item] = typeof source[item] === 'object' ? this.deepCopy(source[item]) : source[item];
      }
      return sourceCopy;
    },

    handleSizeChange(val){
      this.params.pageSize = val
      this.queryPartnersAll()
    },
    handleCurrentChange(val) {
      this.params.pageNum = val
      this.queryPartnersAll()
    },

    remove(data) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        utils.removePartnerAccount(data).then((response)=>{
          if (response.data === true){
            this.dialogVisible = false;
            this.$message.success('删除成功');
            this.queryPartnersAll()
          }else{
            this.$message.error('删除失败')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    update(data){
      utils.updatePartnerAccount(data).then((response)=>{
        if(response.data === true){
          this.$message.success("更新成功")
          this.queryPartnersAll()
        }else{
          this.$message.error("更新失败")
        }
      })
    },
    resetValue(data, name, val){
      console.log(name + " " + val)
      data[name] = val
    },
    addPartner(){
      utils.addPartnerAccount(this.formData).then((response)=>{
        if (response.data === true){
          this.$message.success("添加成功")
          this.dialogVisible = false
          this.queryPartnersAll()
        }else{
          this.$message.error("添加失败")
        }
      })
    },
    queryPartnersAll(){
      if (this.cache === ''){
        this.cache = this.deepCopy(this.params.coinName)
      } else {
        if (this.cache !== this.params.coinName && this.params.coinName !== ''){
          this.params.pageNum = 1
        }
      }
      utils.queryPartnerAccount(this.params).then((response)=>{
        this.isShow = true
        this.total = response.data.total
        this.pages = response.data.pages
        this.pageSize = response.data.size
        this.currentPageNum = response.data.current
        let data = response.data.records
        for (let i in data){
          data[i].updateTime = utils.getLocalTime(data[i].updateTime)
          data[i].createTime = utils.getLocalTime(data[i].createTime)
        }
        this.tableData = data
      })
    },
    clearFormData(){
      this.dialogVisible = false
      this.formData = {
        coin:'',
        userId: '',
        account:'',
        coinArea: ''
      }
    },
    exportExcel(){
      utils.queryAllPartnerAccounts().then((response)=>{
        let data = response.data
        for (let i in data){
          data[i].updateTime = utils.getLocalTime(data[i].updateTime)
          data[i].createTime = utils.getLocalTime(data[i].createTime)
        }
        let startTime = utils.getLocalTime(new Date())
        let title = '项目方' + startTime
        utils.export2Excel(columns, data, title)
      })
    },
  },
  created() {
  },
  computed:{
    params() {
      return {
        coinName:this.coinName,
        pageSize:this.pageSize,
        pageNum:this.currentPageNum
      };
    }
  }
}
</script>

<style scoped>
.block{
  background-color: white;
  margin: 10px 15px 10px 15px;
  padding: 30px 30px 30px 30px;
  height: auto;
}
</style>